exports.errorLog = function(error) {
  console.error(error);
};
